import React from "react";
import { Button, ButtonProps } from "semantic-ui-react";

const ButtonWrapper = (props: ButtonProps) => {
  const style = { fontFamily: `'Cabin', sans-serif` };
  return <Button style={style} {...props} />;
};

export default ButtonWrapper;
